import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/themeFour/vipDetail1.png'
import _imports_1 from '@/assets/themeFour/vip_level.png'


const _hoisted_1 = {
  key: 0,
  class: "vip-card"
}
const _hoisted_2 = { style: {"padding":"0px 10px"} }
const _hoisted_3 = { style: {"font-size":"12px","font-weight":"200"} }
const _hoisted_4 = { class: "img-text" }
const _hoisted_5 = { style: {"margin-left":"3px","font-weight":"bolder"} }
const _hoisted_6 = { style: {"color":"rgba(255, 255, 255, .4)","font-size":"1rem","font-weight":"bold"} }
const _hoisted_7 = { class: "vip-body" }
const _hoisted_8 = { class: "vip-section" }
const _hoisted_9 = { class: "bar" }
const _hoisted_10 = { class: "img-text-bar" }
const _hoisted_11 = { style: {"margin-left":"2px","font-weight":"bolder"} }
const _hoisted_12 = { style: {"color":"rgba(255, 255, 255, .4)","font-weight":"bold","font-size":"1rem"} }
const _hoisted_13 = { style: {"color":"rgba(255, 255, 255, .4)"} }
const _hoisted_14 = { style: {"color":"rgb(255, 154, 79)","font-weight":"bold"} }

import { useUserStore } from '@/stores/user'
import { clickOnCard } from '@/view/profile/supportScript'
import { computed, ref } from 'vue'
import { useRouter } from 'vue-router'
import { formatCurrency } from '@/utils/commonFunction';


export default /*@__PURE__*/_defineComponent({
  __name: 'vipCard',
  setup(__props) {

const router = useRouter()
const userStore = useUserStore()
const isPopping = ref(false)

const currentLevel = computed(() => userStore.VIPData.currentLevel)
const betTotal = computed(() => userStore.VIPData.cumulativeBetTotal)
const betMin = computed(() => userStore.VIPData.bet_min)
const nextLevel = computed(() => userStore.VIPData.nextLevel)

const onClickCard = () => clickOnCard(router, isPopping, '/sd-vip')

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_unref(userStore).vipAvailable)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "vip-route-btn",
            onClick: onClickCard
          }, [
            _cache[0] || (_cache[0] = _createElementVNode("img", { src: _imports_0 }, null, -1)),
            _createElementVNode("span", _hoisted_3, [
              _createTextVNode(_toDisplayString(_ctx.$t('vip.details')), 1),
              _createVNode(_component_van_icon, {
                name: "arrow",
                size: "15"
              })
            ])
          ]),
          _createVNode(_component_van_row, { style: {"display":"flex","align-items":"center","margin":"1rem 0 1.2rem"} }, {
            default: _withCtx(() => [
              _createVNode(_component_van_col, {
                class: "initRow",
                span: "8"
              }, {
                default: _withCtx(() => [
                  _cache[1] || (_cache[1] = _createElementVNode("img", {
                    src: _imports_1,
                    style: {"width":"80%"}
                  }, null, -1)),
                  _createElementVNode("span", _hoisted_4, [
                    _createTextVNode(_toDisplayString(_ctx.$t('vip.title')), 1),
                    _createElementVNode("span", _hoisted_5, _toDisplayString(currentLevel.value), 1)
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_van_col, { span: "14" }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('level.currentLevel')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_van_row, { style: {"align-items":"center"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_col, { span: 19 }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_9, [
                        _cache[2] || (_cache[2] = _createElementVNode("span", { style: {"position":"absolute","left":"35%","top":"6%"} }, null, -1)),
                        _createElementVNode("div", {
                          class: "progress",
                          style: _normalizeStyle({ width: betTotal.value / betMin.value < 1 ? (betTotal.value * 100) / betMin.value + '%' : '100%' })
                        }, null, 4)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_van_col, {
                    span: 4,
                    class: "img-wrapper-bar"
                  }, {
                    default: _withCtx(() => [
                      _cache[3] || (_cache[3] = _createElementVNode("img", { src: _imports_1 }, null, -1)),
                      _createElementVNode("span", _hoisted_10, [
                        _createTextVNode(_toDisplayString(_ctx.$t('vip.title')), 1),
                        _createElementVNode("span", _hoisted_11, _toDisplayString(nextLevel.value), 1)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          _createVNode(_component_van_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_van_col, {
                span: 24,
                style: {"padding":"1.2rem 0 0.8rem"}
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('vip.criteria')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_van_row, { style: {"padding-bottom":"5rem"} }, {
            default: _withCtx(() => [
              _createVNode(_component_van_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_13, [
                    _createTextVNode("•   " + _toDisplayString(_ctx.$t('vip.betRequired')) + ": ", 1),
                    _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(formatCurrency)(betTotal.value)), 1),
                    _createTextVNode("(" + _toDisplayString(_unref(formatCurrency)(betTotal.value)) + " / " + _toDisplayString(_unref(formatCurrency)(betMin.value)) + ") ", 1)
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})